import Vue from "vue";
import VueI18n from "vue-i18n";
import messages from "./i18n_messages.json";

Vue.use(VueI18n);

const locale =
  document.cookie.replace(
    /(?:(?:^|.*;\s*)_LOCALE_\s*=\s*([^;]*).*$)|^.*$/,
    "$1"
  ) || "en";
document.documentElement.setAttribute("lang", locale);

export default new VueI18n({
  locale,
  messages,
  fallbackLocale: "en"
});
